import { motion } from "framer-motion";
import { STATS } from "@/data/content";
import AnimatedNumber from "@/components/AnimatedNumber";
import { usePageText } from "@/hooks/useCms";

export default function Stats() {
  const { data } = usePageText("home-numeros", {
    eyebrow: "Indicadores",
    title: "INXPEK em números.",
    stats: STATS,
  });

  const eyebrow = data?.eyebrow || "Indicadores";
  const title = data?.title || "INXPEK em números.";
  const items = Array.isArray(data?.stats) && data.stats.length > 0
    ? data.stats.map((s) => ({ value: s.value || "", label: s.label || "" }))
    : STATS;

  return (
    <section className="py-14" data-testid="stats-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-2xl mb-8">
          <p className="text-xs tracking-[0.24em] uppercase font-semibold text-[#1698AC] dark:text-[#4FC6D8] mb-4">
            {eyebrow}
          </p>
          <h2 className="font-heading text-4xl sm:text-5xl tracking-tight font-medium leading-[1.1]">
            {title}
          </h2>
        </div>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-10">
          {items.map((s, i) => (
            <motion.div
              key={`${s.label}-${i}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1, duration: 0.6 }}
              className="p-4 lg:p-6"
            >
              <p className="font-heading text-4xl lg:text-5xl font-medium tracking-tighter text-[#1698AC] dark:text-[#4FC6D8]">
                <AnimatedNumber value={s.value} />
              </p>
              <p className="mt-3 text-sm text-slate-500 dark:text-slate-400">{s.label}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
